import { render, staticRenderFns } from "./BookUsageSlidebar.vue?vue&type=template&id=8a5df12c"
import script from "./BookUsageSlidebar.vue?vue&type=script&lang=js"
export * from "./BookUsageSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports